import React, { useEffect, useState } from "react";
import Dashboard from "../../../assets/upgrade-images/Dashboard.svg";
import Bell from "../../../assets/upgrade-images/Bell.svg";
import menu_vector from "../../../assets/upgrade-images/menu_vector.svg";
import menu_vector_dark from "../../../assets/upgrade-images/menu_vector_dark.svg";
import NavItem from "../../../layout/sideBar/sideNavItem";
import { Paths } from "../../routes/routePaths";
import "./_EntrepreneurAdminDashboard.scss";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const EntrepreneurAdminSidebar = () => {
  const history = useHistory();
  const isToggle = useSelector((state) => state.componentReducer.isToggle);
  const [sidebarActive, setSidebarActive] = useState(history.location.pathname);

  useEffect(() => {
    setSidebarActive(history.location.pathname);
  }, [history.location.pathname]);

  const navItems = [
    {
      label: "Assessment Users",
      path: Paths.EntrepreneurAdminAssessmentUsers,
      icon: Dashboard,
      isActive: sidebarActive === Paths.EntrepreneurAdminAssessmentUsers,
      subNavs: []
    },
    {
      label: "Question and Answer",
      path: Paths.EntrepreneurAdminQuestionAnswer,
      icon: Bell,
      isActive: sidebarActive === Paths.EntrepreneurAdminQuestionAnswer,
      subNavs: []
    },
    {
      label: "Access Codes",
      path: Paths.EntrepreneurAdminAccessCodes,
      icon: Bell,
      isActive: sidebarActive === Paths.EntrepreneurAdminAccessCodes,
      subNavs: []
    },
    {
      label: "Master Access Codes",
      path: Paths.EntrepreneurAdminMasterAccessCodes,
      icon: Bell,
      isActive: sidebarActive === Paths.EntrepreneurAdminMasterAccessCodes || sidebarActive === Paths.EntrepreneurAdminMasterAccessCodeSingle,
      subNavs: []
    },
    {
      label: "Contacts",
      path: Paths.EntrepreneurAdminContacts,
      icon: Bell,
      isActive: sidebarActive === Paths.EntrepreneurAdminContacts,
      subNavs: []
    },
    {
      label: "Access Requests",
      path: Paths.EntrepreneurAdminAccessRequests,
      icon: Bell,
      isActive: sidebarActive === Paths.EntrepreneurAdminAccessRequests,
      subNavs: []
    }
  ];

  return (
    <aside
      id="sidebar"
      className={`talwind-dashboard fixed left-0 top-[139px] pb-8 h-[calc(100vh-139px)] flex flex-col justify-between transition-all duration-300 ${
        isToggle ? "w-[63px]" : "w-[230px]"
      } bg-white dark:bg-[#212121] z-[1] overflow-x-hidden`}
    >
      <div className="flex-1 overflow-y-auto min-h-0">
        <ul className="py-4">
          {navItems.map((item, index) => (
            <NavItem key={index} {...item} isHeaderManu={isToggle} />
          ))}
        </ul>
      </div>

      <div className="flex flex-col gap-12">
        <div id="menu_vector" className="w-full transition-all duration-300 px-7">
          <img className="transition-all duration-300 dark:hidden" src={menu_vector} alt="menu vector" />
          <img className="transition-all duration-300 hidden dark:block" src={menu_vector_dark} alt="menu vector dark" />
        </div>
      </div>
    </aside>
  );
};

export default EntrepreneurAdminSidebar;
